
import React, { useEffect, useState } from "react";
import app from "../components/app";

let allMaster = null;

const savePage = async function(appId, pageId, id, pageDataJson) {
  await fetch("https://api-fetch.mediadirhub.com/ai-docs", {
    method:"POST",
    body:JSON.stringify({
      method:"insert",
      type:"repairPages",
      _id:id,
      appId,
      pageId,
      pageDataJson:JSON.stringify(pageDataJson)
    })
  })
  pageDataJson = pageDataJson.map(function(v){
    return repairJson(v);
  });
  await app.fetchPost({
    method: "savePageData",
    appId: appId,
    pageId: pageId,
    id: id,
    pageDataJson: JSON.stringify(pageDataJson),
    userId: "123456",
    publish: 0
  });

  return pageDataJson;
}
 




function compareJsonKeys(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  const missingInObj2 = keys1.filter(key => !(key in obj2));
  const missingInObj1 = keys2.filter(key => !(key in obj1));

  const hasMismatch = missingInObj1.length > 0 || missingInObj2.length > 0;

  return {
    hasMismatch,    // true if any key missing in either object
    missingInObj2,  // keys that exist in obj1 but not in obj2
    missingInObj1   // keys that exist in obj2 but not in obj1
  };
}

function repairJson(data) {
  console.log(data);
  if(allMaster) {
    let item = allMaster.filter(function(v){
      if(v.widgetType === data.widgetType) {
        return true;
      }
      return false;
    });
    item = item[0];
    if(data.properties) {
      const rootKeys = compareProperties(item.properties, data.properties);
      if(rootKeys.length) {
        data.properties = addMissingKeys(rootKeys, item.properties, data.properties);
      }
    }
    Object.keys(data.elements).forEach(function(v){
      if(data.elements[v].properties) {
        const elementKeys = compareProperties(item.elements[v].properties, data.elements[v].properties);
        if(elementKeys.length) {
          data.elements[v].properties = addMissingKeys(elementKeys, item.elements[v].properties, data.elements[v].properties);
        }
      }
      if(data.elements[v].items) {
        data.elements[v].items.forEach(function(ele){
          Object.keys(ele).forEach(function(val){
            if(ele[val].properties) {
              const itemKeys = compareProperties(item.elements[v].items[0][val].properties, ele[val].properties)
              if(itemKeys.length) {
                ele[val].properties = addMissingKeys(itemKeys, item.elements[v].items[0][val].properties, ele[val].properties);
              }
            }
          })
        })
      }
    })
  }
  return data;
}

function addMissingKeys(keys, source, target) {
  const updated = { ...target };
  keys.forEach(function(key){
    updated[key] = source[key];
  });
  return updated;
}

function compareProperties(rightJson, wrongJson) {
  const rightKeys = Object.keys(rightJson);
  const wrongKeys = Object.keys(wrongJson);
  const mismatched = [];

  rightKeys.forEach(function(v){
    if(wrongKeys.indexOf(v) === -1) {
      mismatched.push(v);
    }
  })
  return mismatched;
}


function emptyMismatch(obj) {
  function check(value, keyPath = "") {
    if (Array.isArray(value)) {
      if (value.length === 0) return true;
      return value.some((v, i) => check(v, keyPath + `[${i}]`));
    } else if (value && typeof value === "object") {
      const keys = Object.keys(value);
      if (keys.length === 0) {
        // ✅ Ignore empty objects at "elements"
        if (keyPath.endsWith("elements")) return false;
        return true;
      }
      return keys.some(k => check(value[k], keyPath ? `${keyPath}.${k}` : k));
    }
    return false;
  }

  return check(obj);

}
const matchKeys = function(data, itemIndex, pageName){
  if(!allMaster) {
    return {
        mismatch:null,
        noError:true
    }
  }
   let item = allMaster.filter(function(v){
    if(v.widgetType === data.widgetType) {
      return true;
    }
    return false;
  });
  if(item[0]) {
    item = item[0];
    if(item) {
      const rootKey = compareJsonKeys(item.properties, data.properties);
      let hasMismatch = {
        root:rootKey.hasMismatch?rootKey.missingInObj2:undefined,
        elements:{},
        items:{}
      };
      
      Object.keys(data.elements).forEach(function(v){
        if(data.elements[v].properties) {
          const elementKey = compareJsonKeys(item.elements[v].properties, data.elements[v].properties)
          hasMismatch.elements[v] = elementKey.hasMismatch?elementKey.missingInObj2:undefined;
        }
        if(data.elements[v].items) {
          data.elements[v].items.forEach(function(ele, ind){
            Object.keys(ele).forEach(function(val, index){
              if(ele[val].properties) {
                if(!hasMismatch.items[ind]) {
                  hasMismatch.items[ind] = {};
                }
                
                const itemKey = compareJsonKeys(item.elements[v].items[0][val].properties, ele[val].properties)
                //console.log(itemKey);
                hasMismatch.items[ind][val] = itemKey.hasMismatch?itemKey.missingInObj2:undefined;
              }
            })
          })
        }
      })
      console.log(itemIndex, pageName, data.widgetType, hasMismatch, emptyMismatch(JSON.parse(JSON.stringify(hasMismatch))));
      const finalMismatch = JSON.parse(JSON.stringify(hasMismatch))
      return {
        mismatch:finalMismatch,
        noError:emptyMismatch(finalMismatch)
      }
    }
  }
  
  
  return false;
}

const PageView = function({appId,v, i}){
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [erroData, setErroData] = useState([]);
  useEffect(() => {
    fetchPage();
  }, []);
 
  const fetchPage = async function(id) {
    const response = await app.fetchPost({
      method: "getPage",
      appId: appId,
      pageId: v.pageId
    }, true);
    if(response.pageDataJson) {
      setId(response._id);
      const pageDataJson = JSON.parse(response.pageDataJson);
      setErroData(pageDataJson.map(function(ele, ind){
        return matchKeys(ele, ind, v.pageName)
      }))
      setData(pageDataJson);
    }
  }
  const saveData = function(v) {
    savePage(appId, v.pageId, id, data).then(function(nextData){
      setErroData(nextData.map(function(ele, ind){
          return matchKeys(ele, ind, v.pageName)
      }))
      setData(nextData);
    });
  }
  let saveBtn = false;
  if(erroData.length) {
    erroData.forEach(function(val){
      if(!val.noError) {
        saveBtn = true;
      }
    })
  }
  else {
    saveBtn = false;
  }
  return  <div className="card mb-3 shadow-sm">
  <div className="card-header d-flex fw-bold">
   <span className="flex-grow-1"> {v.pageName}</span>

     <button className={`btn btn-primary btn-sm m-auto ${saveBtn?"":"d-none"}`} onClick={() => saveData(v)} type="button">Save Data</button>

  </div>

  <ul className="list-group list-group-flush">
    {
      data.map(function(ele, index){
        return <li className="list-group-item d-flex justify-content-between align-items-center">
        <span>{ele.widgetType}</span>
        {erroData[index].noError === true?<span className="text-success"><i className="bi appyicon-check-symbol" /></span>:<span className="text-danger"><i className="bi iconz-remove" /></span>}
        
        
      </li>
      })
    }
    
  </ul>
</div>
}

const SaveHeaderFooter = function(){
  const [appId, setAppId] = useState(null);
  const [pages, setPages] = useState([]);
  useEffect(() => {
    if(appId) {
      
      getPages(appId);
    }
  }, [appId]);

  useEffect(() => {
   app.getAllMaster().then(function(response){
    allMaster = response.data.map(function(v){
      const nextItem = JSON.parse(v.data);
      Object.keys(nextItem.elements).forEach(function(v){
          if(nextItem.elements[v].items) {
            nextItem.elements[v].items = nextItem.elements[v].items.filter(function(val, ind){
              if(ind === 0) {
                return true;
              }
              return false;
            })
          }
      });
      
      return nextItem;
    });
   })
  }, []);

  const getPages = async function(id) {
    const data = await app.fetchPost({ "method":"getAllFeaturePages", "appId":id });
    
    setPages(data.data.filter(function(v){
      if(v.isAIPage) {
        return true;
      }
      return false;
    }));
   
  }

  


  return <div className="container p-3">
  {/* Search Box with Button */}
  <div className="input-group mb-4">
    <input id="appId" type="text" className="form-control" placeholder="Enter App ID" />
    <button className="btn btn-primary" type="button" onClick={function(){
      setAppId(document.querySelector("#appId").value);
    }}>
      <i className="bi bi-search" /> Search
    </button>
  </div>
 
  {
    pages.map(function(v,i){
      return <PageView key={`page${i}`} v={v} i={i} appId={appId} />
    })
  }
</div>

}


export default SaveHeaderFooter;


